var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Transport"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.13,17.34h-1.06l-3.17-7.13c-.17-.39-.45-.72-.8-.95-.35-.23-.77-.36-1.2-.36H13.11c-.43,0-.84,.13-1.19,.36-.35,.23-.63,.56-.8,.95l-3.17,7.13h-1.06c-.69,0-1.25,.56-1.25,1.25s.56,1.25,1.25,1.25h.63v6.21s0,.03,0,.04v2.81c0,.58,.23,1.13,.64,1.55,.41,.41,.96,.64,1.55,.64h2.81c.58,0,1.13-.22,1.55-.64,.41-.41,.64-.96,.64-1.55v-1.56h10.63v1.56c0,.58,.23,1.13,.64,1.55,.41,.41,.96,.64,1.55,.64h2.81c.58,0,1.13-.22,1.55-.64,.41-.41,.64-.96,.64-1.55v-2.78s0-.02,0-.03v-6.25h.62c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25ZM13.32,11.41h13.36l2.64,5.93H10.68l2.64-5.93Zm-1.13,17.19h-2.19v-1.25h2.19v1.25Zm15.63,0v-1.25h2.19v1.25h-2.19Zm2.19-3.75H10v-5H30v5Z",
    style: {
      fill: "#141344"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,23.6h1.87c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25h-1.87c-.69,0-1.25,.56-1.25,1.25s.56,1.25,1.25,1.25Z",
    style: {
      fill: "#141344"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.63,23.6h1.87c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25h-1.87c-.69,0-1.25,.56-1.25,1.25s.56,1.25,1.25,1.25Z",
    style: {
      fill: "#141344"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportIcon);
export default __webpack_public_path__ + "static/media/Transport-Icon.b62fc86264e93531fb86b78a81280236.svg";
export { ForwardRef as ReactComponent };